export default function plotDataReducer(
   data,
   plotConfig,
   allValueAxes,
   allCategoryAxes,
   noAxes,
   categories,
   secondaryCategories,
   series,
) {
   const someBoxes = plotConfig.series.some((s) => s.type === "boxplot");
   const somePies = plotConfig.series.some((s) => s.type === "pie");
   const someHeatmaps = plotConfig.series.some((s) => s.type === "heatmap");

   //This takes a row of data and returns the data in a shape that the plot can use
   function dataShape(data) {
      let plotData;
      if (!allValueAxes && !allCategoryAxes && !noAxes) {
         //Boxplots need to compare all val[2] and all val[6] to produce min/max
         if (someBoxes) {
            plotData = [data[2], data[3], data[4], data[5], data[6]];
         } else {
            plotData = data[2];
         }
      } else {
         if (somePies) {
            plotData = { name: data[1], value: data[2] };
         } else if (someHeatmaps) {
            plotData = [
               categories.findIndex((c) => c === data[1]),
               secondaryCategories.findIndex((c) => c === data[2]),
               data[3],
            ];
         } else {
            if (plotConfig.type === "measure") {
               plotData = data[1];
            } else {
               //scatter
               plotData = {
                  value: [data[1], data[2], data[3]],
                  label: data[4],
               };
            }
         }
      }
      return plotData;
   }

   let seriesData = [];

   //Scatter/pie
   if (!categories || categories?.length === 0) {
      //if there are no categories, create the series data and then add data to it (order doesn't matter)
      const uniqueSeries = Array.from(new Set(data.map((d) => d[0])));
      uniqueSeries.forEach((serie) => {
         seriesData.push({
            series: serie,
            data: [],
            seriesConfig: series.find(
               (s) => s.id === plotConfig.id && s.config.label === serie,
            ),
         });
      });

      data.forEach((d) => {
         const existingSeries = seriesData.find((s) => s.series === d[0]);
         if (existingSeries) {
            existingSeries.data.push(dataShape(d));
         }
      });
   } else {
      //Use categories to reduce into an array of series data objects (echarts)
      seriesData = categories.reduce((acc, val) => {
         //initialize the series objects on first run
         if (acc.length === 0) {
            //Get all series
            const uniqueSeries = Array.from(new Set(data.map((d) => d[0])));
            uniqueSeries.forEach((serie) => {
               acc.push({
                  series: serie,
                  data: [],
                  seriesConfig: series.find(
                     (s) => s.id === plotConfig.id && s.config.label === serie,
                  ),
               });
            });
         }
         acc.forEach((a) => {
            //If the series is not in the current category, set it to empty
            if (!data.some((d) => d[1] === val && d[0] === a.series)) {
               a.data.push(
                  dataShape([a.series, val, null, null, null, null, null]),
               );
            } else {
               const values = data.filter(
                  (d) => d[1] === val && d[0] === a.series,
               );
               values.forEach((v) => {
                  a.data.push(dataShape(v));
               });
            }
         });
         return acc;
      }, []);
   }
   return seriesData;
}
